// What the lead form collected, remembered in the visitor's own browser so a
// returning visitor isn't asked again (and doesn't get a second visitor record).
// The phone cookie is the identity key — the avatar backend resolves it to a
// user via /user-by-phone, which on purpose returns only the user id. Name,
// gender and language for the greeting are therefore kept locally as well.

const PHONE_COOKIE = 'es360_phone';
const LEAD_KEY = 'es360_lead';
const ONE_YEAR_S = 31536000;

export function hasLeadDetails(lead) {
  return !!lead && !!(lead.first_name || lead.surname || lead.email || lead.phone);
}

export function savedPhone() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${PHONE_COOKIE}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function savedLead() {
  try {
    const raw = localStorage.getItem(LEAD_KEY);
    const lead = raw ? JSON.parse(raw) : null;
    return lead && typeof lead === 'object' ? lead : null;
  } catch (_) {
    return null; // storage blocked (private mode, sandboxed iframe)
  }
}

export function rememberLead(lead) {
  if (!lead || !lead.phone) return;
  document.cookie = `${PHONE_COOKIE}=${encodeURIComponent(lead.phone)}; max-age=${ONE_YEAR_S}; path=/; SameSite=Lax`;
  try {
    const { first_name = '', surname = '', gender = '', lang = '' } = lead;
    localStorage.setItem(LEAD_KEY, JSON.stringify({ first_name, surname, gender, lang }));
  } catch (_) {}
}
